export const getterTypes = {
  FILES: 'FILES',
  FILE_AUTHORITIES: 'FILE_AUTHORITIES',
  SHARED_FILES: 'SHARED_FILES',
  SHARED_FILE_AUTHORITIES: 'SHARED_FILE_AUTHORITIES',
  FILE_FROM_KEY: 'FILE_FROM_KEY',
  FILE_AUTHORITY_FROM_KEY: 'FILE_AUTHORITY_FROM_KEY',
  IS_MY_FILE_FROM_KEY: 'IS_MY_FILE_FROM_KEY',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
}

export const actionTypes = {
  DISCONNECT_FILE: 'DISCONNECT_FILE',
  LOAD_FILE: 'LOAD_FILE',
  LOAD_FILES: 'LOAD_FILES',
  UPDATE_FILES: 'UPDATE_FILES',
  CREATE_FILE: 'CREATE_FILE',
  CLONE_FILE: 'CLONE_FILE',
  DELETE_FILES: 'DELETE_FILES',
  INVITE_USER: 'INVITE_USER',
  UPDATE_STATUS: 'UPDATE_STATUS',
  UPDATE_USER_AUTHORITIES: 'UPDATE_USER_AUTHORITIES',
}

export const mutationTypes = {
  UPDATE_FILES: 'UPDATE_FILES',
  UPDATE_FILE_AUTHORITIES: 'UPDATE_FILE_AUTHORITIES',
  UPDATE_SHARED_FILES: 'UPDATE_SHARED_FILES',
  UPDATE_SHARED_FILE_AUTHORITIES: 'UPDATE_SHARED_FILE_AUTHORITIES',
  CLEAR_FILES: 'CLEAR_FILES',
  SET_PERMISSION_DENIED: 'SET_PERMISSION_DENIED',
}
